class Role{
    static roles(){
        return [
            {
                'id': 'master',
                'name': '管理者',
                'color': 'red'
            },
            {
                'id':'admin',
                'name': 'マネージャー',
                'color': 'orange'
            },
            {
                'id':'user',
                'name': 'ユーザー',
                'color': 'teal'
            },
            {
                'id':'supporter',
                'name': '経理担当者',
                'color': 'grey'
            },
            {
                'id':'guest',
                'name': 'ゲスト',
                'color': 'black'
            }
        ];
    }

    static get(role_id) {
        let roles = Role.roles();
        for (let i in roles){
            if (roles[i].id == role_id) {
                return roles[i];
            }
        }
    }

}


export default Role;